import { render, staticRenderFns } from "./addCbh.vue?vue&type=template&id=39efebce&scoped=true&"
import script from "./addCbh.vue?vue&type=script&lang=js&"
export * from "./addCbh.vue?vue&type=script&lang=js&"
import style0 from "./addCbh.vue?vue&type=style&index=0&id=39efebce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39efebce",
  null
  
)

export default component.exports